import styled from "styled-components";

export const KanaDisplay = styled.span`
  font-family:  ${props => props.theme.japaneseFont};
  font-size: ${props => props.theme.kanaDisplaySize};
  margin-bottom: 0.3em;
  line-height: 0.8em;
`



// WEBPACK FOOTER //
// ./src/components/QuizBox/KanaDisplay.tsx